// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("icons/icomoon.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("icons/icomoon.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("icons/icomoon.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("icons/icomoon.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("icons/icomoon.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: 'veritone-icons';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('embedded-opentype'),
    url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('woff2'),
    url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('truetype'),
    url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('woff'),
    url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('svg');
  font-weight: normal;
  font-style: normal;
}

[class^='icon-'],
[class*=' icon-'] {
  /* use !important to prevent issues with browser extensions that change fonts */
  font-family: 'veritone-icons' !important;
  speak: none;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;

  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.icon-facematch-app:before {
  content: '\\e99a';
}
.icon-attribution-app:before {
  content: '\\e99b';
}
.icon-redaction-app:before {
  content: '\\e99c';
}
.icon-user-defined-edit:before {
  content: '\\e998';
}
.icon-license-plate:before {
  content: '\\e999';
}
.icon-engines-disabled:before {
  content: '\\e996';
}
.icon-scheduled-jobs:before {
  content: '\\e997';
}
.icon-push:before {
  content: '\\e98e';
}
.icon-pull:before {
  content: '\\e98f';
}
.icon-reduction:before {
  content: '\\e990';
}
.icon-conductor:before {
  content: '\\e991';
}
.icon-intercategory:before {
  content: '\\e992';
}
.icon-intracategory:before {
  content: '\\e993';
}
.icon-correlation:before {
  content: '\\e994';
}
.icon-thumbnail:before {
  content: '\\e995';
}
.icon-max-view:before {
  content: '\\e98d';
}
.icon-job-bundles:before {
  content: '\\e98c';
}
.icon-arrow-back:before {
  content: '\\e98b';
}
.icon-alarm:before {
  content: '\\e98a';
}
.icon-arrow-right:before {
  content: '\\e97c';
}
.icon-list-view:before {
  content: '\\e97d';
}
.icon-grid-view:before {
  content: '\\e97e';
}
.icon-v-analytics:before {
  content: '\\e97f';
}
.icon-info-panel:before {
  content: '\\e989';
}
.icon-run-process:before {
  content: '\\e980';
}
.icon-sources:before {
  content: '\\e981';
}
.icon-streams:before {
  content: '\\e982';
}
.icon-trash:before {
  content: '\\e983';
}
.icon-recent:before {
  content: '\\e984';
}
.icon-show2:before {
  content: '\\e985';
}
.icon-new-folder:before {
  content: '\\e986';
}
.icon-move-folder:before {
  content: '\\e987';
}
.icon-new-media:before {
  content: '\\e988';
}
.icon-show:before {
  content: '\\e978';
}
.icon-hide:before {
  content: '\\e979';
}
.icon-content-copy:before {
  content: '\\e97a';
}
.icon-lock:before {
  content: '\\e97b';
}
.icon-omnystudio:before {
  content: '\\e971';
}
.icon-overview:before {
  content: '\\e977';
}
.icon-api:before {
  content: '\\e972';
}
.icon-engines:before {
  content: '\\e973';
}
.icon-applications:before {
  content: '\\e974';
}
.icon-adapters:before {
  content: '\\e975';
}
.icon-data:before {
  content: '\\e976';
}
.icon-undo:before {
  content: '\\e96c';
}
.icon-redo:before {
  content: '\\e96d';
}
.icon-zoom-circle-out:before {
  content: '\\e96e';
}
.icon-zoom-circle-in:before {
  content: '\\e96f';
}
.icon-timeline-zoom:before {
  content: '\\e970';
}
.icon-shared-folder:before {
  content: '\\e92f';
}
.icon-shared-folder-full:before {
  content: '\\e969';
}
.icon-shared-folder-open:before {
  content: '\\e930';
}
.icon-third-party-data:before {
  content: '\\e965';
}
.icon-station-playout:before {
  content: '\\e967';
}
.icon-developer-app:before {
  content: '\\e968';
}
.icon-ocr:before {
  content: '\\e966';
}
.icon-entity:before {
  content: '\\e963';
}
.icon-library-app:before {
  content: '\\e964';
}
.icon-veritone-discovery:before {
  content: '\\e95d';
}
.icon-veritone-cms:before {
  content: '\\e95e';
}
.icon-veritone-collections:before {
  content: '\\e960';
}
.icon-veritone-admin:before {
  content: '\\e961';
}
.icon-veritone-developer:before {
  content: '\\e962';
}
.icon-root-level:before {
  content: '\\e959';
}
.icon-dashboard_add:before {
  content: '\\e95c';
}
.icon-dashboard:before {
  content: '\\e95b';
}
.icon-reset-filter:before {
  content: '\\e95f';
}
.icon-ic_refresh_black_24px:before {
  content: '\\e95a';
}
.icon-assignment:before {
  content: '\\e85d';
}
.icon-my-watchlists:before {
  content: '\\e0db';
}
.icon-shared:before {
  content: '\\e0dc';
}
.icon-permission:before {
  content: '\\e0da';
}
.icon-broken-link:before {
  content: '\\e958';
}
.icon-shared-folder2:before {
  content: '\\e931';
}
.icon-impersonate:before {
  content: '\\e956';
}
.icon-logo-detection:before {
  content: '\\e955';
}
.icon-audio_det:before {
  content: '\\e953';
}
.icon-sample-media:before {
  content: '\\e952';
}
.icon-Advertiser_onboarding:before {
  content: '\\e94c';
}
.icon-broadcaster_onboarding:before {
  content: '\\e950';
}
.icon-Public-Safety_onboarding:before {
  content: '\\e951';
}
.icon-politics:before {
  content: '\\e94e';
}
.icon-legal:before {
  content: '\\e94b';
}
.icon-other:before {
  content: '\\e94d';
}
.icon-sports:before {
  content: '\\e94f';
}
.icon-email-send:before {
  content: '\\e94a';
}
.icon-close-exit:before {
  content: '\\e946';
}
.icon-info-round:before {
  content: '\\e947';
}
.icon-color-reset:before {
  content: '\\e948';
}
.icon-full-screen-exit:before {
  content: '\\e949';
}
.icon-vimeo_adapter:before {
  content: '\\e945';
}
.icon-zoom-in:before {
  content: '\\e93f';
}
.icon-zoom-out:before {
  content: '\\e940';
}
.icon-full-screen:before {
  content: '\\e944';
}
.icon-radius:before {
  content: '\\e941';
}
.icon-crop:before {
  content: '\\e942';
}
.icon-gps-fixed:before {
  content: '\\e943';
}
.icon-video-rss:before {
  content: '\\e93d';
}
.icon-podcast_rss:before {
  content: '\\e93e';
}
.icon-adapter_rss:before {
  content: '\\e307';
}
.icon-mention-stat:before {
  content: '\\e93b';
}
.icon-gps:before {
  content: '\\e93c';
}
.icon-Amazon-Web-Services_Logo:before {
  content: '\\e93a';
}
.icon-veritone-logo-combo:before {
  content: '\\e92e';
}
.icon-time-expiration:before {
  content: '\\e935';
}
.icon-search-discovery:before {
  content: '\\e936';
}
.icon-ad-verify:before {
  content: '\\e937';
}
.icon-monetize:before {
  content: '\\e938';
}
.icon-report-analytics:before {
  content: '\\e939';
}
.icon-open-folder:before {
  content: '\\e96a';
}
.icon-empty-folder:before {
  content: '\\e96b';
}
.icon-full-folder:before {
  content: '\\e957';
}
.icon-male1:before {
  content: '\\e932';
}
.icon-female1:before {
  content: '\\e933';
}
.icon-malefemale1:before {
  content: '\\e934';
}
.icon-Profile:before {
  content: '\\e7ee';
}
.icon-sftp:before {
  content: '\\e92d';
}
.icon-icon-admin-app:before {
  content: '\\e92b';
}
.icon-ftp:before {
  content: '\\e92c';
}
.icon-Org_add:before {
  content: '\\e92a';
  color: #727272;
}
.icon-upload:before {
  content: '\\e929';
  color: #e5e5e5;
}
.icon-ingest:before {
  content: '\\e920';
}
.icon-manage:before {
  content: '\\e927';
}
.icon-cognition:before {
  content: '\\e928';
}
.icon-webcam:before {
  content: '\\e904';
}
.icon-tag:before {
  content: '\\e903';
}
.icon-onedrive_cloud:before {
  content: '\\e902';
}
.icon-OneDrive:before {
  content: '\\e901';
}
.icon-box:before {
  content: '\\e900';
}
.icon-Googledrive_logo:before {
  content: '\\e921';
}
.icon-icon-appswitcher:before {
  content: '\\30';
}
.icon-savedsearch_selected:before {
  content: '\\31';
}
.icon-savedsearch:before {
  content: '\\32';
}
.icon-collections2:before {
  content: '\\33';
}
.icon-usersettings:before {
  content: '\\35';
}
.icon-collections-app:before {
  content: '\\e91f';
}
.icon-advertiser:before {
  content: '\\36';
}
.icon-broadcaster2:before {
  content: '\\37';
}
.icon-explore:before {
  content: '\\38';
}
.icon-politics2:before {
  content: '\\39';
}
.icon-linkedin:before {
  content: '\\3b';
}
.icon-analytics:before {
  content: '\\61';
}
.icon-plus:before {
  content: '\\62';
}
.icon-filter:before {
  content: '\\64';
}
.icon-facebook:before {
  content: '\\66';
}
.icon-google:before {
  content: '\\67';
}
.icon-recents:before {
  content: '\\68';
}
.icon-instagram:before {
  content: '\\69';
}
.icon-search22:before {
  content: '\\6a';
}
.icon-icon-hamburger:before {
  content: '\\6b';
}
.icon-LoginPassword:before {
  content: '\\6c';
}
.icon-mic:before {
  content: '\\6d';
}
.icon-minus:before {
  content: '\\6e';
}
.icon-pinterest:before {
  content: '\\70';
}
.icon-podcast:before {
  content: '\\71';
}
.icon-youtube:before {
  content: '\\72';
}
.icon-twitter:before {
  content: '\\74';
}
.icon-LoginUser:before {
  content: '\\75';
}
.icon-videocam:before {
  content: '\\76';
}
.icon-profile:before {
  content: '\\77';
}
.icon-youtube-play:before {
  content: '\\79';
}
.icon-add_alert:before {
  content: '\\e003';
}
.icon-sort_by_alpha:before {
  content: '\\e036';
}
.icon-Comments:before {
  content: '\\e04d';
}
.icon-message:before {
  content: '\\e905';
}
.icon-add_circle:before {
  content: '\\e06b';
}
.icon-remove_circle:before {
  content: '\\e080';
}
.icon-format_indent_decrease:before {
  content: '\\e0d7';
}
.icon-file_download:before {
  content: '\\e0ff';
}
.icon-developer_board:before {
  content: '\\e906';
}
.icon-keyboard_arrow_left:before {
  content: '\\e110';
}
.icon-keyboard_arrow_right:before {
  content: '\\e111';
}
.icon-keyboard_backspace:before {
  content: '\\e113';
}
.icon-music_note:before {
  content: '\\e197';
}
.icon-transform:before {
  content: '\\e1b9';
}
.icon-local_post_office:before {
  content: '\\e1ec';
}
.icon-expand_less:before {
  content: '\\e20a';
}
.icon-expand_more:before {
  content: '\\e20b';
}
.icon-fullscreen:before {
  content: '\\e20c';
}
.icon-more_vert:before {
  content: '\\e210';
}
.icon-notifications:before {
  content: '\\e24a';
}
.icon-share2:before {
  content: '\\e25a';
}
.icon-star:before {
  content: '\\e260';
}
.icon-account_circle:before {
  content: '\\e268';
}
.icon-face:before {
  content: '\\e290';
}
.icon-help2:before {
  content: '\\e29b';
}
.icon-report_problem:before {
  content: '\\e2c6';
}
.icon-settings_input_antenna:before {
  content: '\\e2d2';
}
.icon-translation:before {
  content: '\\e2f4';
}
.icon-view_module:before {
  content: '\\e302';
}
.icon-visibility_off:before {
  content: '\\e308';
}
.icon-play_for_work:before {
  content: '\\e317';
}
.icon-log-out:before {
  content: '\\e600';
}
.icon-email_circle:before {
  content: '\\e601';
}
.icon-collections_empty:before {
  content: '\\e602';
}
.icon-female_symbol:before {
  content: '\\e603';
}
.icon-search:before {
  content: '\\e604';
}
.icon-search2:before {
  content: '\\e605';
}
.icon-facebook2:before {
  content: '\\e606';
}
.icon-cog:before {
  content: '\\e607';
}
.icon-padlock:before {
  content: '\\e608';
}
.icon-twitter2:before {
  content: '\\e609';
}
.icon-add:before {
  content: '\\e60a';
}
.icon-cloud_upload:before {
  content: '\\e60b';
}
.icon-calendar:before {
  content: '\\e60c';
}
.icon-calendar2:before {
  content: '\\e60d';
}
.icon-edit:before {
  content: '\\e60e';
}
.icon-info:before {
  content: '\\e60f';
}
.icon-notice:before {
  content: '\\e610';
}
.icon-trashcan:before {
  content: '\\e611';
}
.icon-arrow-add:before {
  content: '\\e612';
}
.icon-results:before {
  content: '\\e613';
}
.icon-exit:before {
  content: '\\e614';
}
.icon-search3:before {
  content: '\\e615';
}
.icon-add156:before {
  content: '\\e616';
}
.icon-agreement:before {
  content: '\\e617';
}
.icon-arrow138:before {
  content: '\\e618';
}
.icon-check54:before {
  content: '\\e619';
}
.icon-code10:before {
  content: '\\e61a';
}
.icon-code32:before {
  content: '\\e61b';
}
.icon-data76:before {
  content: '\\e61c';
}
.icon-development:before {
  content: '\\e61d';
}
.icon-horizontal_arrowscopy:before {
  content: '\\e61e';
}
.icon-expand41:before {
  content: '\\e61f';
}
.icon-gear65:before {
  content: '\\e620';
}
.icon-headphones51:before {
  content: '\\e621';
}
.icon-key189:before {
  content: '\\e622';
}
.icon-music142:before {
  content: '\\e623';
}
.icon-pile:before {
  content: '\\e624';
}
.icon-quit2:before {
  content: '\\e625';
}
.icon-reloading2:before {
  content: '\\e626';
}
.icon-searchcopy:before {
  content: '\\e627';
}
.icon-stop28:before {
  content: '\\e628';
}
.icon-textile:before {
  content: '\\e629';
}
.icon-timer2:before {
  content: '\\e62a';
}
.icon-null:before {
  content: '\\e62b';
}
.icon-responsive16:before {
  content: '\\e62c';
}
.icon-arrow66:before {
  content: '\\e62d';
}
.icon-gears:before {
  content: '\\e62e';
}
.icon-facebook3:before {
  content: '\\e62f';
}
.icon-linkedin2:before {
  content: '\\e630';
}
.icon-location:before {
  content: '\\e631';
}
.icon-phone:before {
  content: '\\e632';
}
.icon-mic2:before {
  content: '\\e633';
}
.icon-panorama:before {
  content: '\\e634';
}
.icon-brain1:before {
  content: '\\e635';
}
.icon-brain2:before {
  content: '\\e636';
}
.icon-reply:before {
  content: '\\e637';
}
.icon-mode_edit2:before {
  content: '\\e638';
}
.icon-forward_10:before {
  content: '\\e639';
}
.icon-pause:before {
  content: '\\e63a';
}
.icon-play_arrow:before {
  content: '\\e63b';
}
.icon-replay_10:before {
  content: '\\e63c';
}
.icon-skip_previous:before {
  content: '\\e63d';
}
.icon-volume_up:before {
  content: '\\e63e';
}
.icon-volume_off2:before {
  content: '\\e63f';
}
.icon-warning:before {
  content: '\\e640';
}
.icon-upload84:before {
  content: '\\e641';
}
.icon-check2:before {
  content: '\\e642';
}
.icon-arrow_slider-64:before {
  content: '\\e643';
}
.icon-insect34:before {
  content: '\\e644';
}
.icon-cloud158:before {
  content: '\\e645';
}
.icon-iconmonstr-quote-5-icon:before {
  content: '\\e646';
}
.icon-sentiment:before {
  content: '\\e647';
}
.icon-transcription:before {
  content: '\\e648';
}
.icon-male_symbol:before {
  content: '\\e649';
}
.icon-description:before {
  content: '\\e64b';
}
.icon-public:before {
  content: '\\e64d';
}
.icon-businessman271:before {
  content: '\\e64e';
}
.icon-person_add2:before {
  content: '\\e64f';
}
.icon-visibility:before {
  content: '\\e650';
}
.icon-finger_print3:before {
  content: '\\e651';
}
.icon-iconmonstr-quote-6-icon:before {
  content: '\\e652';
}
.icon-female:before {
  content: '\\e907';
}
.icon-female_half:before {
  content: '\\e908';
}
.icon-male_half:before {
  content: '\\e909';
}
.icon-male:before {
  content: '\\e90a';
}
.icon-addimage:before {
  content: '\\e90b';
}
.icon-Weather:before {
  content: '\\e90c';
}
.icon-circlecheck:before {
  content: '\\e90d';
}
.icon-arrow-bold-up:before {
  content: '\\e90e';
}
.icon-arrow-down:before {
  content: '\\e90f';
}
.icon-engineprocess:before {
  content: '\\e910';
}
.icon-enginerunning:before {
  content: '\\e911';
}
.icon-heart-o:before {
  content: '\\e912';
}
.icon-heart:before {
  content: '\\e913';
}
.icon-cms:before {
  content: '\\e914';
}
.icon-veritone:before {
  content: '\\e915';
}
.icon-all-folder-closed:before {
  content: '\\e916';
}
.icon-folder-closed:before {
  content: '\\e917';
}
.icon-tags:before {
  content: '\\e918';
}
.icon-tags2:before {
  content: '\\e919';
}
.icon-folder-open:before {
  content: '\\e91a';
}
.icon-watchlist:before {
  content: '\\e91b';
}
.icon-all-folder-open:before {
  content: '\\e91c';
}
.icon-icon-discovery-app:before {
  content: '\\e954';
}
.icon-discovery-app:before {
  content: '\\e91d';
}
.icon-collection_logo:before {
  content: '\\e91e';
}
.icon-discovery_logo:before {
  content: '\\e922';
}
.icon-politics_logo:before {
  content: '\\e923';
}
.icon-object_detection:before {
  content: '\\e924';
}
.icon-dlink:before {
  content: '\\e925';
}
.icon-dropbox:before {
  content: '\\e926';
}
.icon-expand2:before {
  content: '\\f065';
}
.icon-compress:before {
  content: '\\f066';
}
.icon-caret-left:before {
  content: '\\f0d9';
}
.icon-caret-right:before {
  content: '\\f0da';
}
.icon-sort-desc:before {
  content: '\\f0dd';
}
.icon-sort-asc:before {
  content: '\\f0de';
}
.icon-laptop:before {
  content: '\\e31e';
}
.icon-person_add:before {
  content: '\\e7fe';
}
.icon-home:before {
  content: '\\e88a';
}
.icon-person:before {
  content: '\\e7fd';
}
.icon-work:before {
  content: '\\e8f9';
}
`, "",{"version":3,"sources":["webpack://./resources/styles/veritone-icon.css"],"names":[],"mappings":"AAAA;EACE,6BAA6B;EAC7B,4CAA6B;EAC7B;;;;yDAIwC;EACxC,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;EAEE,+EAA+E;EAC/E,wCAAwC;EACxC,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;EACpB,cAAc;;EAEd,sCAAsC;EACtC,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB","sourcesContent":["@font-face {\n  font-family: 'veritone-icons';\n  src: url('icons/icomoon.eot');\n  src: url('icons/icomoon.eot') format('embedded-opentype'),\n    url('icons/icomoon.woff2') format('woff2'),\n    url('icons/icomoon.ttf') format('truetype'),\n    url('icons/icomoon.woff') format('woff'),\n    url('icons/icomoon.svg') format('svg');\n  font-weight: normal;\n  font-style: normal;\n}\n\n[class^='icon-'],\n[class*=' icon-'] {\n  /* use !important to prevent issues with browser extensions that change fonts */\n  font-family: 'veritone-icons' !important;\n  speak: none;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.icon-facematch-app:before {\n  content: '\\e99a';\n}\n.icon-attribution-app:before {\n  content: '\\e99b';\n}\n.icon-redaction-app:before {\n  content: '\\e99c';\n}\n.icon-user-defined-edit:before {\n  content: '\\e998';\n}\n.icon-license-plate:before {\n  content: '\\e999';\n}\n.icon-engines-disabled:before {\n  content: '\\e996';\n}\n.icon-scheduled-jobs:before {\n  content: '\\e997';\n}\n.icon-push:before {\n  content: '\\e98e';\n}\n.icon-pull:before {\n  content: '\\e98f';\n}\n.icon-reduction:before {\n  content: '\\e990';\n}\n.icon-conductor:before {\n  content: '\\e991';\n}\n.icon-intercategory:before {\n  content: '\\e992';\n}\n.icon-intracategory:before {\n  content: '\\e993';\n}\n.icon-correlation:before {\n  content: '\\e994';\n}\n.icon-thumbnail:before {\n  content: '\\e995';\n}\n.icon-max-view:before {\n  content: '\\e98d';\n}\n.icon-job-bundles:before {\n  content: '\\e98c';\n}\n.icon-arrow-back:before {\n  content: '\\e98b';\n}\n.icon-alarm:before {\n  content: '\\e98a';\n}\n.icon-arrow-right:before {\n  content: '\\e97c';\n}\n.icon-list-view:before {\n  content: '\\e97d';\n}\n.icon-grid-view:before {\n  content: '\\e97e';\n}\n.icon-v-analytics:before {\n  content: '\\e97f';\n}\n.icon-info-panel:before {\n  content: '\\e989';\n}\n.icon-run-process:before {\n  content: '\\e980';\n}\n.icon-sources:before {\n  content: '\\e981';\n}\n.icon-streams:before {\n  content: '\\e982';\n}\n.icon-trash:before {\n  content: '\\e983';\n}\n.icon-recent:before {\n  content: '\\e984';\n}\n.icon-show2:before {\n  content: '\\e985';\n}\n.icon-new-folder:before {\n  content: '\\e986';\n}\n.icon-move-folder:before {\n  content: '\\e987';\n}\n.icon-new-media:before {\n  content: '\\e988';\n}\n.icon-show:before {\n  content: '\\e978';\n}\n.icon-hide:before {\n  content: '\\e979';\n}\n.icon-content-copy:before {\n  content: '\\e97a';\n}\n.icon-lock:before {\n  content: '\\e97b';\n}\n.icon-omnystudio:before {\n  content: '\\e971';\n}\n.icon-overview:before {\n  content: '\\e977';\n}\n.icon-api:before {\n  content: '\\e972';\n}\n.icon-engines:before {\n  content: '\\e973';\n}\n.icon-applications:before {\n  content: '\\e974';\n}\n.icon-adapters:before {\n  content: '\\e975';\n}\n.icon-data:before {\n  content: '\\e976';\n}\n.icon-undo:before {\n  content: '\\e96c';\n}\n.icon-redo:before {\n  content: '\\e96d';\n}\n.icon-zoom-circle-out:before {\n  content: '\\e96e';\n}\n.icon-zoom-circle-in:before {\n  content: '\\e96f';\n}\n.icon-timeline-zoom:before {\n  content: '\\e970';\n}\n.icon-shared-folder:before {\n  content: '\\e92f';\n}\n.icon-shared-folder-full:before {\n  content: '\\e969';\n}\n.icon-shared-folder-open:before {\n  content: '\\e930';\n}\n.icon-third-party-data:before {\n  content: '\\e965';\n}\n.icon-station-playout:before {\n  content: '\\e967';\n}\n.icon-developer-app:before {\n  content: '\\e968';\n}\n.icon-ocr:before {\n  content: '\\e966';\n}\n.icon-entity:before {\n  content: '\\e963';\n}\n.icon-library-app:before {\n  content: '\\e964';\n}\n.icon-veritone-discovery:before {\n  content: '\\e95d';\n}\n.icon-veritone-cms:before {\n  content: '\\e95e';\n}\n.icon-veritone-collections:before {\n  content: '\\e960';\n}\n.icon-veritone-admin:before {\n  content: '\\e961';\n}\n.icon-veritone-developer:before {\n  content: '\\e962';\n}\n.icon-root-level:before {\n  content: '\\e959';\n}\n.icon-dashboard_add:before {\n  content: '\\e95c';\n}\n.icon-dashboard:before {\n  content: '\\e95b';\n}\n.icon-reset-filter:before {\n  content: '\\e95f';\n}\n.icon-ic_refresh_black_24px:before {\n  content: '\\e95a';\n}\n.icon-assignment:before {\n  content: '\\e85d';\n}\n.icon-my-watchlists:before {\n  content: '\\e0db';\n}\n.icon-shared:before {\n  content: '\\e0dc';\n}\n.icon-permission:before {\n  content: '\\e0da';\n}\n.icon-broken-link:before {\n  content: '\\e958';\n}\n.icon-shared-folder2:before {\n  content: '\\e931';\n}\n.icon-impersonate:before {\n  content: '\\e956';\n}\n.icon-logo-detection:before {\n  content: '\\e955';\n}\n.icon-audio_det:before {\n  content: '\\e953';\n}\n.icon-sample-media:before {\n  content: '\\e952';\n}\n.icon-Advertiser_onboarding:before {\n  content: '\\e94c';\n}\n.icon-broadcaster_onboarding:before {\n  content: '\\e950';\n}\n.icon-Public-Safety_onboarding:before {\n  content: '\\e951';\n}\n.icon-politics:before {\n  content: '\\e94e';\n}\n.icon-legal:before {\n  content: '\\e94b';\n}\n.icon-other:before {\n  content: '\\e94d';\n}\n.icon-sports:before {\n  content: '\\e94f';\n}\n.icon-email-send:before {\n  content: '\\e94a';\n}\n.icon-close-exit:before {\n  content: '\\e946';\n}\n.icon-info-round:before {\n  content: '\\e947';\n}\n.icon-color-reset:before {\n  content: '\\e948';\n}\n.icon-full-screen-exit:before {\n  content: '\\e949';\n}\n.icon-vimeo_adapter:before {\n  content: '\\e945';\n}\n.icon-zoom-in:before {\n  content: '\\e93f';\n}\n.icon-zoom-out:before {\n  content: '\\e940';\n}\n.icon-full-screen:before {\n  content: '\\e944';\n}\n.icon-radius:before {\n  content: '\\e941';\n}\n.icon-crop:before {\n  content: '\\e942';\n}\n.icon-gps-fixed:before {\n  content: '\\e943';\n}\n.icon-video-rss:before {\n  content: '\\e93d';\n}\n.icon-podcast_rss:before {\n  content: '\\e93e';\n}\n.icon-adapter_rss:before {\n  content: '\\e307';\n}\n.icon-mention-stat:before {\n  content: '\\e93b';\n}\n.icon-gps:before {\n  content: '\\e93c';\n}\n.icon-Amazon-Web-Services_Logo:before {\n  content: '\\e93a';\n}\n.icon-veritone-logo-combo:before {\n  content: '\\e92e';\n}\n.icon-time-expiration:before {\n  content: '\\e935';\n}\n.icon-search-discovery:before {\n  content: '\\e936';\n}\n.icon-ad-verify:before {\n  content: '\\e937';\n}\n.icon-monetize:before {\n  content: '\\e938';\n}\n.icon-report-analytics:before {\n  content: '\\e939';\n}\n.icon-open-folder:before {\n  content: '\\e96a';\n}\n.icon-empty-folder:before {\n  content: '\\e96b';\n}\n.icon-full-folder:before {\n  content: '\\e957';\n}\n.icon-male1:before {\n  content: '\\e932';\n}\n.icon-female1:before {\n  content: '\\e933';\n}\n.icon-malefemale1:before {\n  content: '\\e934';\n}\n.icon-Profile:before {\n  content: '\\e7ee';\n}\n.icon-sftp:before {\n  content: '\\e92d';\n}\n.icon-icon-admin-app:before {\n  content: '\\e92b';\n}\n.icon-ftp:before {\n  content: '\\e92c';\n}\n.icon-Org_add:before {\n  content: '\\e92a';\n  color: #727272;\n}\n.icon-upload:before {\n  content: '\\e929';\n  color: #e5e5e5;\n}\n.icon-ingest:before {\n  content: '\\e920';\n}\n.icon-manage:before {\n  content: '\\e927';\n}\n.icon-cognition:before {\n  content: '\\e928';\n}\n.icon-webcam:before {\n  content: '\\e904';\n}\n.icon-tag:before {\n  content: '\\e903';\n}\n.icon-onedrive_cloud:before {\n  content: '\\e902';\n}\n.icon-OneDrive:before {\n  content: '\\e901';\n}\n.icon-box:before {\n  content: '\\e900';\n}\n.icon-Googledrive_logo:before {\n  content: '\\e921';\n}\n.icon-icon-appswitcher:before {\n  content: '\\30';\n}\n.icon-savedsearch_selected:before {\n  content: '\\31';\n}\n.icon-savedsearch:before {\n  content: '\\32';\n}\n.icon-collections2:before {\n  content: '\\33';\n}\n.icon-usersettings:before {\n  content: '\\35';\n}\n.icon-collections-app:before {\n  content: '\\e91f';\n}\n.icon-advertiser:before {\n  content: '\\36';\n}\n.icon-broadcaster2:before {\n  content: '\\37';\n}\n.icon-explore:before {\n  content: '\\38';\n}\n.icon-politics2:before {\n  content: '\\39';\n}\n.icon-linkedin:before {\n  content: '\\3b';\n}\n.icon-analytics:before {\n  content: '\\61';\n}\n.icon-plus:before {\n  content: '\\62';\n}\n.icon-filter:before {\n  content: '\\64';\n}\n.icon-facebook:before {\n  content: '\\66';\n}\n.icon-google:before {\n  content: '\\67';\n}\n.icon-recents:before {\n  content: '\\68';\n}\n.icon-instagram:before {\n  content: '\\69';\n}\n.icon-search22:before {\n  content: '\\6a';\n}\n.icon-icon-hamburger:before {\n  content: '\\6b';\n}\n.icon-LoginPassword:before {\n  content: '\\6c';\n}\n.icon-mic:before {\n  content: '\\6d';\n}\n.icon-minus:before {\n  content: '\\6e';\n}\n.icon-pinterest:before {\n  content: '\\70';\n}\n.icon-podcast:before {\n  content: '\\71';\n}\n.icon-youtube:before {\n  content: '\\72';\n}\n.icon-twitter:before {\n  content: '\\74';\n}\n.icon-LoginUser:before {\n  content: '\\75';\n}\n.icon-videocam:before {\n  content: '\\76';\n}\n.icon-profile:before {\n  content: '\\77';\n}\n.icon-youtube-play:before {\n  content: '\\79';\n}\n.icon-add_alert:before {\n  content: '\\e003';\n}\n.icon-sort_by_alpha:before {\n  content: '\\e036';\n}\n.icon-Comments:before {\n  content: '\\e04d';\n}\n.icon-message:before {\n  content: '\\e905';\n}\n.icon-add_circle:before {\n  content: '\\e06b';\n}\n.icon-remove_circle:before {\n  content: '\\e080';\n}\n.icon-format_indent_decrease:before {\n  content: '\\e0d7';\n}\n.icon-file_download:before {\n  content: '\\e0ff';\n}\n.icon-developer_board:before {\n  content: '\\e906';\n}\n.icon-keyboard_arrow_left:before {\n  content: '\\e110';\n}\n.icon-keyboard_arrow_right:before {\n  content: '\\e111';\n}\n.icon-keyboard_backspace:before {\n  content: '\\e113';\n}\n.icon-music_note:before {\n  content: '\\e197';\n}\n.icon-transform:before {\n  content: '\\e1b9';\n}\n.icon-local_post_office:before {\n  content: '\\e1ec';\n}\n.icon-expand_less:before {\n  content: '\\e20a';\n}\n.icon-expand_more:before {\n  content: '\\e20b';\n}\n.icon-fullscreen:before {\n  content: '\\e20c';\n}\n.icon-more_vert:before {\n  content: '\\e210';\n}\n.icon-notifications:before {\n  content: '\\e24a';\n}\n.icon-share2:before {\n  content: '\\e25a';\n}\n.icon-star:before {\n  content: '\\e260';\n}\n.icon-account_circle:before {\n  content: '\\e268';\n}\n.icon-face:before {\n  content: '\\e290';\n}\n.icon-help2:before {\n  content: '\\e29b';\n}\n.icon-report_problem:before {\n  content: '\\e2c6';\n}\n.icon-settings_input_antenna:before {\n  content: '\\e2d2';\n}\n.icon-translation:before {\n  content: '\\e2f4';\n}\n.icon-view_module:before {\n  content: '\\e302';\n}\n.icon-visibility_off:before {\n  content: '\\e308';\n}\n.icon-play_for_work:before {\n  content: '\\e317';\n}\n.icon-log-out:before {\n  content: '\\e600';\n}\n.icon-email_circle:before {\n  content: '\\e601';\n}\n.icon-collections_empty:before {\n  content: '\\e602';\n}\n.icon-female_symbol:before {\n  content: '\\e603';\n}\n.icon-search:before {\n  content: '\\e604';\n}\n.icon-search2:before {\n  content: '\\e605';\n}\n.icon-facebook2:before {\n  content: '\\e606';\n}\n.icon-cog:before {\n  content: '\\e607';\n}\n.icon-padlock:before {\n  content: '\\e608';\n}\n.icon-twitter2:before {\n  content: '\\e609';\n}\n.icon-add:before {\n  content: '\\e60a';\n}\n.icon-cloud_upload:before {\n  content: '\\e60b';\n}\n.icon-calendar:before {\n  content: '\\e60c';\n}\n.icon-calendar2:before {\n  content: '\\e60d';\n}\n.icon-edit:before {\n  content: '\\e60e';\n}\n.icon-info:before {\n  content: '\\e60f';\n}\n.icon-notice:before {\n  content: '\\e610';\n}\n.icon-trashcan:before {\n  content: '\\e611';\n}\n.icon-arrow-add:before {\n  content: '\\e612';\n}\n.icon-results:before {\n  content: '\\e613';\n}\n.icon-exit:before {\n  content: '\\e614';\n}\n.icon-search3:before {\n  content: '\\e615';\n}\n.icon-add156:before {\n  content: '\\e616';\n}\n.icon-agreement:before {\n  content: '\\e617';\n}\n.icon-arrow138:before {\n  content: '\\e618';\n}\n.icon-check54:before {\n  content: '\\e619';\n}\n.icon-code10:before {\n  content: '\\e61a';\n}\n.icon-code32:before {\n  content: '\\e61b';\n}\n.icon-data76:before {\n  content: '\\e61c';\n}\n.icon-development:before {\n  content: '\\e61d';\n}\n.icon-horizontal_arrowscopy:before {\n  content: '\\e61e';\n}\n.icon-expand41:before {\n  content: '\\e61f';\n}\n.icon-gear65:before {\n  content: '\\e620';\n}\n.icon-headphones51:before {\n  content: '\\e621';\n}\n.icon-key189:before {\n  content: '\\e622';\n}\n.icon-music142:before {\n  content: '\\e623';\n}\n.icon-pile:before {\n  content: '\\e624';\n}\n.icon-quit2:before {\n  content: '\\e625';\n}\n.icon-reloading2:before {\n  content: '\\e626';\n}\n.icon-searchcopy:before {\n  content: '\\e627';\n}\n.icon-stop28:before {\n  content: '\\e628';\n}\n.icon-textile:before {\n  content: '\\e629';\n}\n.icon-timer2:before {\n  content: '\\e62a';\n}\n.icon-null:before {\n  content: '\\e62b';\n}\n.icon-responsive16:before {\n  content: '\\e62c';\n}\n.icon-arrow66:before {\n  content: '\\e62d';\n}\n.icon-gears:before {\n  content: '\\e62e';\n}\n.icon-facebook3:before {\n  content: '\\e62f';\n}\n.icon-linkedin2:before {\n  content: '\\e630';\n}\n.icon-location:before {\n  content: '\\e631';\n}\n.icon-phone:before {\n  content: '\\e632';\n}\n.icon-mic2:before {\n  content: '\\e633';\n}\n.icon-panorama:before {\n  content: '\\e634';\n}\n.icon-brain1:before {\n  content: '\\e635';\n}\n.icon-brain2:before {\n  content: '\\e636';\n}\n.icon-reply:before {\n  content: '\\e637';\n}\n.icon-mode_edit2:before {\n  content: '\\e638';\n}\n.icon-forward_10:before {\n  content: '\\e639';\n}\n.icon-pause:before {\n  content: '\\e63a';\n}\n.icon-play_arrow:before {\n  content: '\\e63b';\n}\n.icon-replay_10:before {\n  content: '\\e63c';\n}\n.icon-skip_previous:before {\n  content: '\\e63d';\n}\n.icon-volume_up:before {\n  content: '\\e63e';\n}\n.icon-volume_off2:before {\n  content: '\\e63f';\n}\n.icon-warning:before {\n  content: '\\e640';\n}\n.icon-upload84:before {\n  content: '\\e641';\n}\n.icon-check2:before {\n  content: '\\e642';\n}\n.icon-arrow_slider-64:before {\n  content: '\\e643';\n}\n.icon-insect34:before {\n  content: '\\e644';\n}\n.icon-cloud158:before {\n  content: '\\e645';\n}\n.icon-iconmonstr-quote-5-icon:before {\n  content: '\\e646';\n}\n.icon-sentiment:before {\n  content: '\\e647';\n}\n.icon-transcription:before {\n  content: '\\e648';\n}\n.icon-male_symbol:before {\n  content: '\\e649';\n}\n.icon-description:before {\n  content: '\\e64b';\n}\n.icon-public:before {\n  content: '\\e64d';\n}\n.icon-businessman271:before {\n  content: '\\e64e';\n}\n.icon-person_add2:before {\n  content: '\\e64f';\n}\n.icon-visibility:before {\n  content: '\\e650';\n}\n.icon-finger_print3:before {\n  content: '\\e651';\n}\n.icon-iconmonstr-quote-6-icon:before {\n  content: '\\e652';\n}\n.icon-female:before {\n  content: '\\e907';\n}\n.icon-female_half:before {\n  content: '\\e908';\n}\n.icon-male_half:before {\n  content: '\\e909';\n}\n.icon-male:before {\n  content: '\\e90a';\n}\n.icon-addimage:before {\n  content: '\\e90b';\n}\n.icon-Weather:before {\n  content: '\\e90c';\n}\n.icon-circlecheck:before {\n  content: '\\e90d';\n}\n.icon-arrow-bold-up:before {\n  content: '\\e90e';\n}\n.icon-arrow-down:before {\n  content: '\\e90f';\n}\n.icon-engineprocess:before {\n  content: '\\e910';\n}\n.icon-enginerunning:before {\n  content: '\\e911';\n}\n.icon-heart-o:before {\n  content: '\\e912';\n}\n.icon-heart:before {\n  content: '\\e913';\n}\n.icon-cms:before {\n  content: '\\e914';\n}\n.icon-veritone:before {\n  content: '\\e915';\n}\n.icon-all-folder-closed:before {\n  content: '\\e916';\n}\n.icon-folder-closed:before {\n  content: '\\e917';\n}\n.icon-tags:before {\n  content: '\\e918';\n}\n.icon-tags2:before {\n  content: '\\e919';\n}\n.icon-folder-open:before {\n  content: '\\e91a';\n}\n.icon-watchlist:before {\n  content: '\\e91b';\n}\n.icon-all-folder-open:before {\n  content: '\\e91c';\n}\n.icon-icon-discovery-app:before {\n  content: '\\e954';\n}\n.icon-discovery-app:before {\n  content: '\\e91d';\n}\n.icon-collection_logo:before {\n  content: '\\e91e';\n}\n.icon-discovery_logo:before {\n  content: '\\e922';\n}\n.icon-politics_logo:before {\n  content: '\\e923';\n}\n.icon-object_detection:before {\n  content: '\\e924';\n}\n.icon-dlink:before {\n  content: '\\e925';\n}\n.icon-dropbox:before {\n  content: '\\e926';\n}\n.icon-expand2:before {\n  content: '\\f065';\n}\n.icon-compress:before {\n  content: '\\f066';\n}\n.icon-caret-left:before {\n  content: '\\f0d9';\n}\n.icon-caret-right:before {\n  content: '\\f0da';\n}\n.icon-sort-desc:before {\n  content: '\\f0dd';\n}\n.icon-sort-asc:before {\n  content: '\\f0de';\n}\n.icon-laptop:before {\n  content: '\\e31e';\n}\n.icon-person_add:before {\n  content: '\\e7fe';\n}\n.icon-home:before {\n  content: '\\e88a';\n}\n.icon-person:before {\n  content: '\\e7fd';\n}\n.icon-work:before {\n  content: '\\e8f9';\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
